import _convertToHtml from "../functions/quill/convertToHtml.js";
import _convertWordMapToSubtitles from "../functions/special/convertWordMapToSubtitles.js";
import _convertWordMapToTranscript from "../functions/special/convertWordMapToTranscript.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _Event from "../classes/event.js";
const Event = _Event;
const getFormatOptions = _getFormatOptions;
const convertWordMapToTranscript = _convertWordMapToTranscript;
const convertWordMapToSubtitles = _convertWordMapToSubtitles;
const convertToHtml = _convertToHtml;

/* Gladia pre-recorded result (GET /v2/pre-recorded/{id}). Times are in seconds; speaker is on the utterance, not the word. */
function utterancesToWordMap(utterances) {
  let wordMap = [];
  utterances.forEach(utterance => {
    let speakers = utterance.speaker !== undefined && utterance.speaker !== null ? ["SP" + utterance.speaker] : [];
    (utterance.words || []).forEach(word => {
      let text = (word.word || "").trim();
      if (!text) {
        return;
      }
      wordMap.push(new Event({
        start: parseFloat(word.start),
        end: parseFloat(word.end),
        text: text,
        confidence: word.confidence,
        speakers: speakers
      }));
    });
  });
  return wordMap;
}
export default {
  decode: function (input, options) {
    let events = [],
      decodingOptions = getFormatOptions(options.formatOptions);
    let fileJson = JSON.parse(input);
    let result = fileJson.result || fileJson;
    let importType = decodingOptions["Import Type"] || "subtitle";
    let maxLines = decodingOptions["Max Lines"] || 2;
    let maxChars = decodingOptions["Max Characters"] || 32;
    let importTarget = decodingOptions["Import Target"] || "transcript";
    let languageCode = decodingOptions["Language Code"];
    let utterances;
    if (importTarget.toLowerCase() === "translation" && languageCode) {
      let translation = (result.translation && result.translation.results || []).find(res => (res.languages || []).includes(languageCode));
      utterances = translation ? translation.utterances || [] : [];

      /* Translated utterances may not carry word timings. Fall back to one event per utterance. */
      if (!utterances.some(utterance => utterance.words && utterance.words.length > 0)) {
        return utterances.filter(utterance => utterance.text).map(utterance => new Event({
          start: parseFloat(utterance.start),
          end: parseFloat(utterance.end),
          text: convertToHtml(utterance.text.trim()),
          speakers: utterance.speaker !== undefined && utterance.speaker !== null ? ["SP" + utterance.speaker] : [],
          yOffset: options.window.height * -0.10
        }));
      }
    } else {
      utterances = result.transcription && result.transcription.utterances || [];
    }
    let wordMap = utterancesToWordMap(utterances);
    if (importType === "word map") {
      events = wordMap;
    } else if (importType === "transcription") {
      events = convertWordMapToTranscript(wordMap, maxLines, maxChars, options.window);
    } else {
      events = convertWordMapToSubtitles(wordMap, maxLines, maxChars, options.window);
    }
    return events;
  },
  encode: function (eventGroup, options) {
    throw new Error("JSON Transcript files are not supported for encoding by Closed Caption Converter.");
  },
  preProcess: {
    encode: function (eventGroup) {
      return eventGroup;
    },
    decode: function (input) {
      /* All */
      return input;
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      /* Order by start time */
      eventGroup.events.sort((eventA, eventB) => {
        return eventA.start - eventB.start;
      });
      eventGroup.events = eventGroup.events.filter((event, index, events) => {
        if (index > 0) {
          return event.start != events[index - 1].start;
        } else {
          return true;
        }
      });
      return eventGroup;
    }
  }
};